import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

export default function AuthWrapper(props: any) {
  const router = useRouter();
  const userToken = useSelector((state: any) => {
    return state.auth.accessToken;
  });

  useEffect(() => {
    if (userToken) {
      router.push("/");
    }
  }, []);

  return userToken ? null : props.children;
}
